// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_key_link_hinge/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_key_link_hinge: ModuleSchema = {
  "id": "core_key_link_hinge",
  "uniqueId": "B3D_Q3SYM",
  "createdAt": "2026-10-16T00:00:00Z",
  "updatedAt": "2026-10-16T12:01:59.953Z",
  "label": "Print-in-Place Linked Clickers",
  "description": "Two clicker links joined print-in-place by a vertical-plane C-hook capturing a transverse axle in the end recess; pivot axis spans the link width (CG_HNG01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_HNG01",
    "flexi-link",
    "print-in-place-joint"
  ],
  "sliders": [
    {
      "key": "barWidth",
      "label": "Axle Section Height",
      "min": 1.8,
      "max": 3.2,
      "default": 2.2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "radialClearance",
      "label": "Hook-to-Axle Print Clearance",
      "min": 0.2,
      "max": 0.8,
      "default": 0.35,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "mouthGap",
      "label": "Hook Mouth",
      "min": 3,
      "max": 4.5,
      "default": 3.8,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "ringWall",
      "label": "Hook Wall Thickness",
      "min": 1,
      "max": 2.4,
      "default": 1.4,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "jointThickness",
      "label": "Hook Thickness across Link Width",
      "min": 1.6,
      "max": 3.2,
      "default": 2.4,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "armWidth",
      "label": "Hook Shank Thickness",
      "min": 2,
      "max": 4,
      "default": 2.6,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "clicker_bodies",
      "label": "Links, Recess, Axle and Hook",
      "default": "#F59E0B",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "mx_switch_sim",
      "label": "MX Switch Simulations",
      "default": "#6CC7C3",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keycaps",
      "label": "Keycaps",
      "default": "#F4F1E8",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "clicker_pair",
      "label": "Two Flexi-Linked Clickers",
      "name": "Two Flexi-Linked Clickers",
      "color": "#F59E0B",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "clicker_bodies",
          "label": "Links, Recess, Axle and Hook",
          "name": "Links, Recess, Axle and Hook",
          "groupId": 0,
          "colorKey": "clicker_bodies",
          "defaultColor": "#F59E0B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "mx_switch_sim",
          "label": "MX Switch Simulations",
          "name": "MX Switch Simulations",
          "groupId": 1,
          "colorKey": "mx_switch_sim",
          "defaultColor": "#6CC7C3",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "keycaps",
          "label": "Keycaps",
          "name": "Keycaps",
          "groupId": 2,
          "colorKey": "keycaps",
          "defaultColor": "#F4F1E8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Two Linked Clickers"
    },
    {
      "id": "0",
      "label": "Download STL - Links and Print-in-Place Joint"
    },
    {
      "id": "1",
      "label": "Download STL - Switch Simulations"
    },
    {
      "id": "2",
      "label": "Download STL - Keycaps"
    }
  ]
};
